import * as React from 'react';

import {getTagColorGridItems} from 'shells/colors/helpers';
import {FormField} from 'shells/form/form-field';
import {GridSelector} from 'shells/grid-selector/grid-selector';
import type {ColorItem} from 'shells/grid-selector/grid-selector';
import {Popover} from 'shells/popover/popover';
import {PopoverForm} from 'shells/popover-form/popover-form';
import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

type Props = {
    anchor?: HTMLElement | null | undefined;
    anchorElementId?: string | null | undefined;
    onClose: () => void;
    onSave: (arg1: {id?: string; name: string; color: string}) => void;
    name?: string | null | undefined;
    color?: string | null | undefined;
    isSaving: boolean;
    isEditing: boolean;
    errorMessage: string | null | undefined;
};

export function EditCreateTagPopover(props: Props) {
    const tagColorGridItems: ColorItem[] = getTagColorGridItems();

    const selectedColor = props.color
        ? tagColorGridItems.find((swatch) => swatch.id === props.color)
        : undefined;

    const [tagName, setTagName] = React.useState<string>(props.name || '');
    const [tagColor, setTagColor] = React.useState<ColorItem>(
        // @ts-expect-error
        selectedColor || tagColorGridItems[0]
    );

    return (
        <Popover
            anchor={props.anchor}
            // @ts-expect-error
            anchorElementId={props.anchorElementId}
            location='bottom'
            onBlur={props.onClose}
        >
            <PopoverForm
                title={props.isEditing ? 'Edit tag' : 'Add a tag'}
                saveButtonText={props.isEditing ? 'Save changes' : 'Create tag'}
                saveButtonSavingText={props.isEditing ? 'Saving...' : 'Creating...'}
                saveButtonSuccessText={props.isEditing ? 'Saved' : 'Done'}
                width={250}
                onClose={props.onClose}
                saveButtonDisabled={!tagName}
                isSaving={props.isSaving}
                errorSaving={Boolean(props.errorMessage)}
                onSubmit={() => {
                    props.onSave({name: tagName, color: tagColor.id});
                }}
            >
                <FormField
                    innerId='name'
                    label={'Name'}
                    isRequired={true}
                    errorMessage={props.errorMessage || ''}
                >
                    <TextField
                        focusOnMount={true}
                        selectOnFocus={true}
                        placeholder='Contractor'
                        value={tagName || ''}
                        onChange={(enteredName) => setTagName(enteredName)}
                        hasError={Boolean(props.errorMessage)}
                    />
                </FormField>
                {/* @ts-expect-error */}
                <div spacing={8} className='flex flex-dir-col gap-8 pb-16'>
                    <Body size='normal' color='medium'>
                        Color
                    </Body>
                    <GridSelector
                        // Even though the type is already ColorItem[], we need to map it so flow doesn't complain
                        items={tagColorGridItems.map((item) => ({
                            id: item.id,
                            type: 'color',
                            content: item.content,
                        }))}
                        selectedItemId={tagColor.id}
                        onSelectItem={(itemId) => {
                            const newColor = tagColorGridItems.find(
                                (swatch) => swatch.id === itemId
                            );
                            // @ts-expect-error
                            setTagColor(newColor || tagColorGridItems[0]);
                        }}
                    />
                </div>
            </PopoverForm>
        </Popover>
    );
}
